import { MODAL_HIDE_ACTION, MODAL_SHOW_ACTION, MODAL_UPDATE_ACTION, } from '../actions/ModalActions';
const updateObj = (state, modalType, payload, modalSetting) => {
    const currentValue = state[modalType] || {};
    const { isEqual, isShow: show } = modalSetting;
    const { modalId } = payload;
    if (modalId && isEqual) {
        const currentModalId = (state[modalType] || {}).modalId;
        if (currentModalId !== modalId) {
            // IDが違っていたら更新しない
            return state;
        }
    }
    return Object.assign(Object.assign({}, state), { [modalType]: Object.assign(Object.assign(Object.assign({}, currentValue), payload), { show: show === null ? currentValue.show : show }) });
};
// eslint-disable-next-line default-param-last
export default (state = {}, { modalType, payload = {}, type }) => {
    switch (type) {
        case MODAL_SHOW_ACTION: {
            return updateObj(state, modalType, payload, {
                isShow: true,
            });
        }
        case MODAL_HIDE_ACTION: {
            const { modalId } = payload;
            return updateObj(state, modalType, payload, {
                isEqual: !!modalId,
                isShow: false,
            });
        }
        case MODAL_UPDATE_ACTION: {
            return updateObj(state, modalType, payload, {
                isEqual: true,
                isShow: null,
            });
        }
        default: {
            return state;
        }
    }
};
